import { InjectionToken } from '@angular/core';
import { MeetingSourceOrigin } from '@vendasta/meetings';

export const PLATFORM_INTEGRATIONS_PARTNER_ID_INJECTION_TOKEN$ = 'PI_PARTNER_ID';
export const PLATFORM_INTEGRATIONS_NAMESPACE_INJECTION_TOKEN$ = 'PI_NAMESPACE';
export const PLATFORM_INTEGRATIONS_ORIGIN_INJECTION_TOKEN = new InjectionToken<MeetingSourceOrigin>('Origin');
export const PLATFORM_INTEGRATIONS_CONTEXT_INJECTION_TOKEN$ = 'PI_CONTEXT';
export const PLATFORM_INTEGRATIONS_MARKET_ID_INJECTION_TOKEN$ = 'PI_MARKET_ID';
export const PLATFORM_INTEGRATIONS_USER_ID_INJECTION_TOKEN$ = 'PI_USER_ID';
export const PLATFORM_INTEGRATIONS_IS_LOCAL_SEO_INJECTION_TOKEN = new InjectionToken<boolean>('IS_LOCAL_SEO_CONTEXT');

export const PARTNER_GOOGLE_MEET_INTEGRATION_ID_PROD = '36945e18-0018-4de8-9fd1-be75c2f3401e';
export const PARTNER_GOOGLE_MEET_INTEGRATION_ID_DEMO = '869466f5-df3b-4a13-8681-1dfe0ce3f481';

export const PLATFORM_INTEGRATIONS_INTEGRATION_TYPE_AVALARA = 'Avalara';
